module.exports = __webpack_public_path__ + "static/travelzik2-eb06bffec97cc3702b0525ca8c02394f.png";